<template>
    <div :style="styles.widthLimitter">
        <div :style="styles.renderingAreaProvider">
            <transition name="fade">
                <div class="video-overlay-image" @click="overlayClicked()" v-show="show_video_overlay">
                    <img :src="video_overlay_image">
                </div>
            </transition>
            <iframe :src="src" :style="styles.iframe" frameborder="0" allowfullscreen="true" id="youtube_video"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: [
      "maxWidth",
      "videoId",
      "video_overlay_image",
    ],
    data() {
        return {
          src: `https://www.youtube.com/embed/${this.videoId}`,
          show_video_overlay: this.video_overlay_image != undefined,
            styles: {
                widthLimitter: {
                    maxWidth: this.maxWidth ? this.maxWidth : null,
                },
                renderingAreaProvider: {
                    background: "#f0f0f0",
                    height: 0,
                    margin: "1rem 0",
                    /*
                     * - '56.25%' indicates the aspect rasio (9/16 = 56.25%).
                     * - note that percentage inside 'padding-(top|bottom)' is calculated based on
                     *   its current width. this is a specification of 'calc' used inside
                     *   the 'padding-(top|bottom)' property.
                     *
                     * see: https://nathan.gs/2018/01/07/responsive-slideshare-iframe/
                     */
                    paddingBottom: "calc(56.25%)",
                    position: "relative",
                    width: "100%"
                },
                iframe: {
                    height: "100%",
                    left: 0,
                    position: "absolute",
                    top: 0,
                    width: "100%"
                }
            }
        };
    },
  methods: {
    overlayClicked(event){
      this.show_video_overlay = false;
      this.src += "?autoplay=1";
    }
  },
};
</script>
